import { Currency } from '.';
import { BaseCountry } from './base-country';

export class Country extends BaseCountry {
  defaultCurrency: Currency;
  defaultJurisdiction: Country;
}
